import type Store from "@ember-data/store";
import type Patient from "parog-web/models/patient";

export default async function fetchChatMessageJes(
  store: Store,
  patient: Patient,
  page = 1,
  nbByPage = 10
): Promise<{ pageCount?: number }> {
  const response = (await store.query(
    "patient-chat-message-sent-journal-event",
    {
      filter: {
        patient_id: patient.id
      },
      include: [
        "creator",
        "triggering-journal-event.file-attachments",
        "triggering-journal-event.creator"
      ].join(","),
      page: {
        number: page,
        size: nbByPage
      },
      sort: "-occurred_at"
    }
  )) as unknown as { meta: { "record-count": string; "page-count": string } };

  return {
    pageCount: parseInt(response.meta?.["page-count"]) || undefined
  };
}
